import * as R from 'ramda';
function getCustomTooltipSizeStyles(size) {
  return require("./".concat(size, ".css"));
}
export var getSizeStyles = R.memoizeWith(R.identity, getCustomTooltipSizeStyles);